<div class="margin-top">
  <fgbcl-auction-wallet-details [id]="id"></fgbcl-auction-wallet-details>
</div>
